export function NoData({children = 'Aucune donnés à afficher pour le momement '} : {children?: any}) {
    return <div style={{height: '150px', width: '80%',  margin: 'auto', marginTop: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', borderRadius: '5px', }}>
    
        <div style={{color: 'rgba(0,0,0,.8)', display: 'flex', flexDirection: 'column',  alignItems: 'center'}}>
            <img src="/images/empty-boite.png"  width={80} alt="empty"/>
            <br/>
            <p>{children}</p>
        </div>
    </div>
}